import { Client, ReferralPartner } from '.';
import { DateString } from '../types';

export type TReferralCommissionId = number;

export interface ReferralCommission {
  id: TReferralCommissionId;
  client: Client;
  referral_partner: ReferralPartner;
  reporting_period_type_id: number;
  percent_rate: number;
  payment_structure: string;
  start_reporting_quarter: DateString;
  end_reporting_quarter?: DateString;
}
